import {
  PersonMatchProfile,
  UpdatePersonMatchProfilePayload,
} from '@hakimo-ui/hakimo/types';
import useAuthenticatedMutation from '../shared/useAuthenticatedMutation';

export function useUpdatePersonMatchProfile(
  profileId: string,
  onSuccess?: (data: PersonMatchProfile) => void,
  onError?: (err: Error) => void
) {
  const url = `/v2/orm/person_profile/${profileId}`;

  const request = new Request(url, {
    method: 'PATCH',
  });

  return useAuthenticatedMutation<
    PersonMatchProfile,
    UpdatePersonMatchProfilePayload
  >(request, {
    onSuccessInvalidationKeys: [
      ['person_match_profiles'],
      ['person_match_profiles', profileId],
    ],
    onSuccess,
    onError,
    responseModifier: async (response) => {
      const respJson = await response.json();
      return respJson as PersonMatchProfile;
    },
  });
}

export default useUpdatePersonMatchProfile;
